import * as K from 'common/constants';
import { Cell, Column } from 'common/graphqlTypes';
import './DashboardTransposeTable.scss';

type DashboardTransposeTableType = {
  columns: Column[];
  rowValues: Cell[];
};

/**
 * This component is to show transpose table view in dashboard panel
 *
 * @prop columns     Array of labels listed in the column value
 * @prop rowValues   Array of values to be displayed, component accepts only one row
 */

function DashboardTransposeTable({ columns, rowValues }: DashboardTransposeTableType): JSX.Element {
  return (
    <>
      {columns.map((column: any, index: number) => (
        <div className="DashboardTransposeTable" key={index}>
          <div className="DashboardTransposeTable__Labels">{column.name}</div>
          <div
            className={
              column.name === K.STATUS && rowValues[index].value === K.UNHEALTHY_STATUS
                ? 'DashboardTransposeTable__UnhealthyStatus'
                : ''
            }
          >
            {rowValues[index].value}
          </div>
        </div>
      ))}
    </>
  );
}

export default DashboardTransposeTable;
